import type { ScanPhotoTimeline } from '@kaiizen/kai-scan-template-system';

/**
 * The shared vocabulary of the Progress Alt grid: what a column is, and how columns are named so the
 * panel can remember which of them are open. Rows are named by `getRowNumber`, the ordinal their own
 * label leads with.
 */

/** A timeline column plus the presentation the grid needs to label it. */
export type ProgressAltColumn = {
  groupId: string;
  taskId?: string;
  title: string;
  subtitle: string;
};

/** Identifies a column across the grid and its owner's expansion state. */
export const getColumnKey = (column: { groupId: string; taskId?: string }) => `${column.groupId}:${column.taskId ?? 'group'}`;

/** Widest cell in the column — how far it has to open to lay every photo out side by side. */
export const getMaxPhotoCount = (timeline: ScanPhotoTimeline, columnIndex: number) =>
  Math.max(1, ...timeline.rows.map(row => row.cells[columnIndex]?.photos.length ?? 0));

/**
 * "6 photos", "1 photo" — the count and its noun in agreement. An adjective, where one is given, sits
 * between them: "5 undated photos".
 */
export const getPhotoCountLabel = (photoCount: number, adjective?: string) =>
  `${photoCount} ${adjective ? `${adjective} ` : ''}${photoCount === 1 ? 'photo' : 'photos'}`;
